// extracted by mini-css-extract-plugin
module.exports = {"applyButton":"styles_applyButton__1PKpi"};